// components/XlsIcon.js
import React from "react";
import { SvgIcon } from "@mui/material";

const XlsIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="m2.859 2.877l12.57-1.795a.5.5 0 0 1 .571.494v20.848a.5.5 0 0 1-.57.494L2.858 21.123a1 1 0 0 1-.859-.99V3.867a1 1 0 0 1 .859-.99M17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4zm-6.8 9L13 8h-2.4L9 10.286L7.4 8H5l2.8 4L5 16h2.4L9 13.714L10.6 16H13z" />
    </SvgIcon>
  );
};

export default XlsIcon;
